/**
 * DEV-1255. Экраны и сообщения об отказе в доступе.
 *
 * Отдельным файлом, а не в ru.ts: тексты читает поддержка вместе с
 * администратором, и держать их в одном месте дешевле, чем искать по трём
 * трёхтысячным словарям.
 */
export const accessMessages = {
  ru: {
    common: {
      access: {
        // ——— /no-access: принципал не относится к CRM ———
        noAccessTitle: 'Доступ в CRM закрыт',
        noAccessDescription:
          'Учётной записи {email} не выдан доступ к CRM. Если он нужен для работы — попросите администратора добавить роль, а затем нажмите «Проверить снова».',
        noAccessRecheck: 'Проверить снова',
        noAccessRecheckHint:
          'Выданные права вступают в силу в течение полуминуты — если доступ только что добавили, подождите и проверьте ещё раз.',
        noAccessStillClosed:
          'Доступа всё ещё нет. Права применяются до 30 секунд — попробуйте позже.',
        switchAccount: 'Войти под другой учётной записью',

        // ——— /dashboard/forbidden: раздел закрыт ———
        forbiddenTitle: 'Раздел недоступен',
        forbiddenTitleNamed: 'Раздел «{section}» недоступен',
        forbiddenDescription:
          'У вашей роли нет доступа к этому разделу. Если он нужен для работы — напишите администратору.',
        forbiddenSectionKey: 'Ключ раздела для администратора: {key}',
        toDashboard: 'На главную',
        logout: 'Выйти',

        // ——— 403 на открытом экране ———
        permissionsChanged:
          'Права изменились: сервер отказал в доступе к этим данным. Обновляем список доступного — изменения прав применяются до 30 секунд.',
      },
    },
  },
  en: {
    common: {
      access: {
        noAccessTitle: 'No access to CRM',
        noAccessDescription:
          'The account {email} has not been granted access to CRM. If you need it, ask an administrator to add a role, then press “Check again”.',
        noAccessRecheck: 'Check again',
        noAccessRecheckHint:
          'Granted permissions take up to half a minute to apply — if access was just added, wait and check again.',
        noAccessStillClosed:
          'Still no access. Permissions take up to 30 seconds to apply — try again shortly.',
        switchAccount: 'Sign in with another account',

        forbiddenTitle: 'Section unavailable',
        forbiddenTitleNamed: 'Section “{section}” is unavailable',
        forbiddenDescription:
          'Your role has no access to this section. If you need it for work, contact an administrator.',
        forbiddenSectionKey: 'Section key for the administrator: {key}',
        toDashboard: 'To dashboard',
        logout: 'Sign out',

        permissionsChanged:
          'Permissions changed: the server denied access to this data. Refreshing what is available — permission changes take up to 30 seconds to apply.',
      },
    },
  },
  vn: {
    common: {
      access: {
        noAccessTitle: 'Không có quyền vào CRM',
        noAccessDescription:
          'Tài khoản {email} chưa được cấp quyền vào CRM. Nếu bạn cần, hãy đề nghị quản trị viên thêm vai trò, sau đó nhấn «Kiểm tra lại».',
        noAccessRecheck: 'Kiểm tra lại',
        noAccessRecheckHint:
          'Quyền vừa cấp cần đến nửa phút để có hiệu lực — nếu vừa được thêm, hãy đợi và kiểm tra lại.',
        noAccessStillClosed:
          'Vẫn chưa có quyền. Thay đổi quyền cần đến 30 giây để áp dụng — hãy thử lại sau.',
        switchAccount: 'Đăng nhập bằng tài khoản khác',

        forbiddenTitle: 'Mục không khả dụng',
        forbiddenTitleNamed: 'Mục «{section}» không khả dụng',
        forbiddenDescription:
          'Vai trò của bạn không có quyền vào mục này. Nếu cần cho công việc, hãy liên hệ quản trị viên.',
        forbiddenSectionKey: 'Khoá mục dành cho quản trị viên: {key}',
        toDashboard: 'Về trang chính',
        logout: 'Đăng xuất',

        permissionsChanged:
          'Quyền đã thay đổi: máy chủ từ chối truy cập dữ liệu này. Đang cập nhật danh sách khả dụng — thay đổi quyền cần đến 30 giây.',
      },
    },
  },
}
